import { Button } from '../../../../../../widgets/buttons';
import { Checkbox } from '../../../../../../widgets/checkbox';
import { Dialog } from '../../../../../../widgets/dialog';
import { FormControl } from '../../../../../../widgets/formControl';
import { Input } from '../../../../../../widgets/input';
import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ComposerAttributeNode } from '../../../configurator-components/composer-editors/attributes/composerAttributesModels';
import { ComposerAttributeNodeAdapter } from '../helpers/composerNodesAdapter';

interface ComposerMergeAttributeOutput {
    newAttribute: ComposerAttributeNode;
    attributesToMerge?: ComposerAttributeNode[];
    deleteSourceAttributes: boolean;
}
interface ComposerMergeAttributeDialogProps {
    attributesList: ComposerAttributeNode[];
    onConfirm: (attributes: ComposerMergeAttributeOutput) => void;
}
const ComposerMergeAttributeWindow = styled(Dialog)`
    max-width: 600px;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
`;
const FormInline = styled.div`
display: flex
;
    flex-direction: row;
    align-items: center;
	min-width: 300px;
    gap: 15px;
}
`;

const FormBlock = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    max-height: 300px;
    overflow: auto;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
`;

export const ComposerMergeAttributeDialog: React.FC<ComposerMergeAttributeDialogProps> = ({ attributesList, onConfirm }) => {
    const [deleteSourceAttributeState, setDeleteSourceAttributeState] = React.useState<boolean>(false);
    const [attributesToMerge, setAttributesToMerge] = React.useState<ComposerAttributeNode[]>([]);
    const [attributeName, setAttributeName] = React.useState<string>('');
    const [attributeCode, setAttributeCode] = React.useState<string>('');

    const handleConfirm = () => {
        const newParsedAttribute = ComposerAttributeNodeAdapter.toNode(ComposerAttributeNodeAdapter.createNew());
        newParsedAttribute.name = attributeName;
        newParsedAttribute.code = attributeCode;
        const result: ComposerMergeAttributeOutput = {
            newAttribute: newParsedAttribute,
            attributesToMerge,
            deleteSourceAttributes: deleteSourceAttributeState
        };
        onConfirm(result);
    };

    const onAttributeToMerge = (attribute: ComposerAttributeNode) => {
        const exists = attributesToMerge.find((a) => a.id === attribute.id);
        if (exists) {
            setAttributesToMerge(attributesToMerge.filter((a) => a.id !== attribute.id));
        } else {
            setAttributesToMerge([...attributesToMerge, attribute]);
        }
    };

    return (
        <Dialog
            title={T._('Select Attributes to Merge', 'Admin')}
            windowDecorator={ComposerMergeAttributeWindow}
            buttons={[{ label: T._('Confirm', 'Admin'), onClick: handleConfirm }]}
        >
            <Container>
                <FormInline>
                    <p>{T._('Please select below the attributes you want to merge into a single attribute.', 'Admin')}</p>
                    <Button
                        onClick={() => {
                            if (attributesList.length === attributesToMerge.length) {
                                setAttributesToMerge([]);
                            } else {
                                attributesList.forEach((attr) => {
                                    if (!attributesToMerge.includes(attr)) {
                                        setAttributesToMerge((prev) => [...prev, attr]);
                                    }
                                });
                            }
                        }}
                    >
                        {attributesList.length === attributesToMerge.length ? T._('Deselect all attributes', 'Admin') : T._('Select all attributes', 'Admin')}
                    </Button>
                </FormInline>
                <FormControl label={T._('Attributes to merge', 'Admin')}>
                    <FormInline>
                        {attributesList.map((attr) => (
                            <FormBlock key={attr.id} onClick={() => onAttributeToMerge(attr)}>
                                <Checkbox label={attr.name} checked={attributesToMerge.includes(attr)} onChange={() => {}} />
                            </FormBlock>
                        ))}
                    </FormInline>
                </FormControl>
                <FormControl label={T._('New Attribute Name', 'Admin')}>
                    <span style={{ fontSize: '0.8em', color: '#888' }}>{T._('Mandatory field', 'Admin')}</span>
                    <Input type='text' value={attributeName} onChange={(e) => setAttributeName(e.target.value)} />
                </FormControl>
                <FormControl label={T._('New Attribute Code', 'Admin')}>
                    <span style={{ fontSize: '0.8em', color: '#888' }}>{T._('Mandatory field', 'Admin')}</span>
                    <Input type='text' value={attributeCode} onChange={(e) => setAttributeCode(e.target.value)} />
                </FormControl>
                <FormInline>
                    <Checkbox
                        label={T._('Delete source attributes', 'Admin')}
                        checked={deleteSourceAttributeState}
                        onChange={(e) => {
                            setDeleteSourceAttributeState(e);
                        }}
                    />
                </FormInline>
            </Container>
        </Dialog>
    );
};
